import React, { useEffect, useState } from "react"
// Account status state synced with localStorage and custom event

import { Layout } from "antd"
import styles from "./Index.module.css"
import { Outlet, useLocation } from "react-router-dom"
import { Sidebar } from "./Sidebar"
import { useDispatch, useSelector } from "react-redux"
import { setProHomeMenuItemActive } from "store/pro-home-menu"
import classNames from "classnames"
import { routes } from "router/routes"
import { ProgressRow } from "./ProgressRow"
import { guideSelector } from "store/user"
import VerificationStatusPage from "pagesV2/pro/Verification/VerificationStatusPage"
import useActiveGuide from "hooks/useActiveClient"
import { AiAssistant } from "pagesV2/client/AiAssistant"
import AccountNoticeBanner from "./AccountNoticeBanner"
const { Content } = Layout

export const ProHomeLayout = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [menuId, setMenuId] = useState()
  const guide = useSelector(guideSelector)
  const { isInProgress, isPending } = useActiveGuide()

  useEffect(() => {
    const menuPath = location.pathname.split(routes.proHomeRootPath()).find(Boolean)
    const menuId = menuPath?.split("/").find(Boolean)
    dispatch(setProHomeMenuItemActive(menuId))
    setMenuId(menuId)
  }, [dispatch, location.pathname])

  return (
    <div className={styles.wrapper}>
      {(isInProgress || isPending) && <ProgressRow isPending={isPending} />}
      <AccountNoticeBanner user={guide} />
      <Layout className={styles.layout}>
        <Sidebar />
        <Content className={classNames(styles.content, menuId && styles.hasMenuId)}>
          <VerificationStatusPage>
            <Outlet />
            <AiAssistant />
          </VerificationStatusPage>
        </Content>
      </Layout>
    </div>
  )
}
